import Icon from 'lqa-ui/lib/Components/Icon';
import React from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import './styles.scss';

const PageContainer = styled.div`
position: fixed;
width: 100%;
align-items: center;
height: 100%;
text-align: center;
padding-top:65%;
background-color: #4FADA6;
  `;
const HeaderContainer = styled.div`
  font-weight: 600;
font-size: 20px;
line-height: 24px;
color: #FFFFFF;
margin-bottom: 1.5rem;
margin-top: 1.5rem

  `;
const TextContainer = styled.div`
  font-weight: 400;
font-size: 20px;
line-height: 24px;
color: #FFFFFF;
margin-bottom: 1.5rem;
  `;
const ContinueContainer = styled.div`
text-align: center;
text-decoration-line: underline;
font-weight: 600;
font-size: 20px;
line-height: 24px;
margin-top:10px;
color: #FFFFFF;
margin-bottom: 1.5rem;
`;
const Success = () => {
  const location = useLocation();
  const loc: any = {...location};
  return (
      <PageContainer>
          <span className="white-icon"><Icon kind="tick-points" width={80} height={80} /></span>
          <HeaderContainer>You're all set</HeaderContainer>
          <TextContainer>Welcome to {loc.state.hotelName}</TextContainer>
          <ContinueContainer><span onClick={() => {window.location.href = '/login'; }}>Continue</span></ContinueContainer>
          </PageContainer>
  );
};

export default Success;
